import { SvgIcon, SvgIconProps } from '@mui/material';

export function DraggableIcon({ ...props }: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 18 18" fill="currentColor">
        <path d="M5 14V12H2V2H12V5H14V3.99999H16V5.99999H18V4C18 3.45 17.8042 2.97916 17.4125 2.5875C17.0208 2.19583 16.55 2 16 2L14 2C14 1.45 13.8042 0.979167 13.4125 0.5875C13.0208 0.195833 12.55 0 12 0H2C1.45 0 0.979167 0.195833 0.5875 0.5875C0.195833 0.979167 0 1.45 0 2V12C0 12.55 0.195833 13.0208 0.5875 13.4125C0.979167 13.8042 1.45 14 2 14L2 15.9999C2 16.5499 2.19583 17.0207 2.5875 17.4124C2.97916 17.8041 3.45 17.9999 4 17.9999L6 17.9999V15.9999H4L4 14H5ZM18 7.99999V12H16V7.99999H18ZM18 16V14H16V16L14 16V18H16C16.55 18 17.0208 17.8042 17.4125 17.4125C17.8042 17.0208 18 16.55 18 16ZM12 16V18H7.99999V16H12ZM5.6585 5.24742L12 10.7962V7H14V13V14H13H7V12H10.3386L4.3415 6.75258L5.6585 5.24742Z" />
      </svg>
    </SvgIcon>
  );
}

export function DeletePropertyMappingIcon({ ...props }: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.37906 22.5858C8.59801 23.3668 7.33168 23.3668 6.55063 22.5858L1.52509 17.5603C0.744046 16.7792 0.744046 15.5129 1.52509 14.7318L14.8427 1.41422C15.6238 0.633167 16.8901 0.633166 17.6711 1.41421L22.6967 6.43975C23.4777 7.2208 23.4777 8.48713 22.6967 9.26818L9.37906 22.5858Z"
          fill="currentColor"
        />
        <path
          d="M8.55867 21.9876C8.16815 22.3781 7.53498 22.3781 7.14446 21.9876L2.1212 16.9643C1.73067 16.5738 1.73067 15.9406 2.1212 15.5501L7.07095 10.6003L13.5084 17.0378L8.55867 21.9876Z"
          fill="white"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    </SvgIcon>
  );
}

export function DeleteLoopIcon({ ...props }: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.5 18L8.1 16.6L11.65 13.05L8.1 9.5L9.5 8.1L13.05 11.65L16.6 8.1L18 9.5L14.45 13.05L18 16.6L16.6 18L13.05 14.45L9.5 18Z"
          fill="currentColor"
        />
        <path
          d="M6 16V18H2C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979166 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979166 18 1.45 18 2V6H16V2H2V16H6Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}
